common.View.create('shop::website.modules.shopCustomer.manage.orders.Show', {

    onDOMLoad() {
        this.initAddToCart();
    },

    initAddToCart() {
        this.element

            // Listen to add to cart button click.
            .find('button[name="addToCart"]:enabled')
                .click(this.onAddToCartClick.bind(this))
                .end();
    },

    async onAddToCartClick(event) {
        // TODO Low: Enable and fix the 'flash' once the next requests executes super fast?
        // Swal.showLoading();

        // Get product variant
        let variant = $(event.currentTarget).data('variant');

        this.element.find('button[name="addToCart"]').addClass('loading');

        // Request
        let response = await $.post(variant);

        // Update amount in header.
        $('.website\\:\\:layouts-main-Header').data('instance')
            .setTotalPhysicalAmount(response.totalPhysicalAmount);

        // Update mini cart
        $('.shop\\:\\:website-modules-shopCheckout-cart-partials-MiniCart').data('instance')
            .replaceMiniCart(response.miniCartView, false);

        // Add clicked class on button
        this.element.find('button[name="addToCart"]').removeClass('loading').addClass('clicked');

        // Remove clicked after x seconds
        setTimeout(() => {
            this.element.find('button[name="addToCart"]').removeClass('clicked');
        }, 2000);

        // TODO Medium: Style
        // Navigate to checkout?
        if ((await Swal.fire({
            title: 'Toegevoegd',
            text: 'Het product is toegevoegd aan je winkelwagen.',
            icon: 'success',
            showCancelButton: true,
            cancelButtonColor: '#707070',
            cancelButtonText: 'Verder winkelen',
            confirmButtonColor: '#4a7729',
            confirmButtonText: 'Nu afrekenen'
        })).value)
            document.location.href = this.element.data('checkout-url');
    },

});
